import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams } from 'ionic-angular';
import { ValidationResultModel } from '../../../../_foundation/models/validation.models';
import { VesselCrewEditor, VesselCrewOvertimeEditor } from '../../../../models/vessel-crew/vessel-crew.models';
import { VesselCrewService } from '../../../../services/vessel-crew/vessel-crew.service';
import { EnumSummary } from '../../../../models/base/base.model';
import { AppConfig } from '../../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-vessel-crew-overtime-edit',
  templateUrl: 'vessel-crew-overtime-edit.html',
})
export class VesselCrewOvertimeEditPage {

  config = AppConfig.settings;
  editor: VesselCrewOvertimeEditor;
  editorNew: VesselCrewOvertimeEditor;
  model: VesselCrewEditor;
  callback: Function;
  isCreate: boolean;
  validationResult: ValidationResultModel;
  overtimeSummaries: EnumSummary[];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public vesselCrewService: VesselCrewService,
              public events: Events,
  ) {

    this.vesselCrewService.getOvertimeRequestedBys().then(value => {
      this.overtimeSummaries = value;
      this.editor = this.navParams.get('editor');
      this.editorNew = Object.assign({}, this.editor);
      this.model = this.navParams.get('model');
      this.callback = this.navParams.get('callback');
      this.isCreate = this.navParams.get('isCreate');
    });
  }

  ionViewDidLoad() {

  }

  compareFn(e1: EnumSummary, e2: EnumSummary): boolean {
    return e1 && e2 ? e1.id === e2.id : e1 === e2;
  }


  save() {
    this.vesselCrewService.validateOvertime(this.editorNew).subscribe(() => {
        if (this.isCreate) {
          this.model.overtime.push(this.editorNew);
        } else {
          const index = this.model.overtime.findIndex(value => value.id === this.editorNew.id);
          this.model.overtime[index] = this.editorNew;
        }

        this.events.publish('saveVessel');

        this.navCtrl.pop();
      },
      error => {
        if (error.status && error.status === 412) {
          this.validationResult = error.error;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/vessel-crew/vessel-crew-overtime-edit/vessel-crew-overtime-edit.ts